import { ActionMenu } from '@/components/action-menu';
import { toaster } from '@/components/ui/toaster';
import { api } from '@/lib/api';
import { UserDto } from '@/lib/ServerApi';
import { CustomCellRendererProps } from '@ag-grid-community/react';
import { Box, Icon } from '@chakra-ui/react';
import { SquarePen, TimerReset } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface UserManagementActionRendererProps extends CustomCellRendererProps<UserDto> {
    userId: string;
}

export function UserManagementActionRenderer({ data }: UserManagementActionRendererProps) {
    const navigate = useNavigate();

    return (
        <Box pl="4px">
            <ActionMenu
                actions={[
                    {
                        id: 'edit',
                        action: () => navigate(`/user/${data?.id}`),
                        icon: (
                            <Icon boxSize={5}>
                                <SquarePen />
                            </Icon>
                        ),
                        label: 'Edit',
                    },
                    {
                        id: 'password-reset',
                        action: async () => {
                            if (data?.email) {
                                await api.authentication.forgotPassword({ email: data?.email });
                                toaster.create({
                                    title: 'Password reset sent',
                                    type: 'success',
                                    duration: 3000,
                                });
                            }
                        },
                        icon: (
                            <Icon boxSize={5}>
                                <TimerReset />
                            </Icon>
                        ),
                        label: 'Password Reset',
                    },
                ]}
            />
        </Box>
    );
}
